import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/employee_lifecycle/pages/RootPage'))
const OverviewPage = React.lazy(() => import('modules/employee_lifecycle/pages/OverviewPage'))
const WorkflowsPage = React.lazy(() => import('modules/employee_lifecycle/pages/WorkflowsPage'))
const WorkflowEditPage = React.lazy(
  () => import('modules/employee_lifecycle/pages/WorkflowEditPage')
)
const WorkflowTypePage = React.lazy(
  () => import('modules/employee_lifecycle/pages/WorkflowTypePage')
)

export const employeeLifecycleRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employeeLifecycle.path,
      element: <RootPage />,
      handle: {
        module: 'employee_lifecycle',
        meta: () => ({
          title: i18n.t('employee_lifecycle.breadcrumbs.title'),
          description: i18n.t('employee_lifecycle.breadcrumbs.description'),
          illustration: 'automations',
        }),
      },
      children: [
        {
          index: true,
          element: <OverviewPage />,
        },
        {
          path: navigation.employeeLifecycle.workflows.path,
          children: [
            {
              path: navigation.employeeLifecycle.workflows.onboarding.path,
              element: <WorkflowsPage />,
              handle: {
                meta: () => ({
                  title: i18n.t('employee_lifecycle.workflows.header.onboarding'),
                  description: i18n.t('employee_lifecycle.breadcrumbs.description'),
                  illustration: 'automations',
                }),
              },
            },
            {
              path: navigation.employeeLifecycle.workflows.id.edit.path,
              element: <WorkflowEditPage />,
              handle: {
                meta: () => ({
                  title: i18n.t('employee_lifecycle.breadcrumbs.edit_workflow'),
                  description: i18n.t('employee_lifecycle.breadcrumbs.description'),
                  illustration: 'automations',
                }),
              },
            },
          ],
        },
        {
          path: navigation.employeeLifecycle.workflowType.path,
          element: <WorkflowTypePage />,
          handle: {
            meta: ({ params }) => ({
              title: params['workflowType'] || 'Workflow Type',
              description: i18n.t('employee_lifecycle.breadcrumbs.description'),
              illustration: 'automations',
            }),
          },
        },
      ],
    },
  ]
}
